import styled from "styled-components";

import { styles } from "../Input/styles";

export const Container = styled.div`
  input[data-input="date"] {
    ${styles}
  }
`;

export const Wrapper = styled.div``;

export const WrapperChecklist = styled.div`
  display: flex;
  align-items: center;

  margin-top: 0.5rem;

  .input-container {
    display: flex;
    justify-content: center;
    align-items: center;

    flex: initial;
  }

  label {
    margin-left: 0.5rem;
  }
`;

export const WrapperInput = styled.div`
  display: flex;

  input {
    flex: 1;
  }
`;
